import type { InstagramData } from "./types";

export default function extractUsername(data: InstagramData) {
  return data?.personal_information?.profile_user?.[0]?.string_map_data
    ?.Username?.value;
}
